'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _ElementPresentational = require('./ElementPresentational');

var _ElementPresentational2 = _interopRequireDefault(_ElementPresentational);

var _ElementContainer = require('./ElementContainer');

var _ElementContainer2 = _interopRequireDefault(_ElementContainer);

require('./Element.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Element = function Element(props) {
    var isPresentational = props.isPresentational;

    var DisplayElement = isPresentational ? _ElementPresentational2.default : _ElementContainer2.default;

    return _react2.default.createElement(DisplayElement, props);
};

Element.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    isPresentational: _propTypes2.default.bool
};

exports.default = (0, _recompose.pure)(Element);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/Element.js
// module id = 449
// module chunks = 0